import React , {useDebugValue, useEffect, useState} from 'react';
import BarcodeScanner from 'react-qr-barcode-scanner';
import { AreaTitle } from './appBar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCamera, faFaceFrown, faFaceSmile } from '@fortawesome/free-solid-svg-icons';
import { Button } from '@progress/kendo-react-buttons';
import { Input } from '@progress/kendo-react-inputs';
import { Dialog, DialogActionsBar} from '@progress/kendo-react-dialogs';



export const ReservationForm =()=>{
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const key = urlParams.get("key");
    const test = urlParams.get("test");
    const [area,setArea]=useState(undefined);
    const [showScanner,setShowScanner]=useState(true);
    const [scanValue,setScanValue]=useState("");    
    const [hasBlocks,setHasBlocks]=useState(false);
    const [resOpen, setResOpen]=useState(false);
    const [resExists,setResExists]=useState(false);
    const [maxRides,setMaxRides]=useState(false);
    const [isYouth,setIsYouth]=useState(false);
    const [tomorrow,setTomorrow]=useState(undefined);
    const [participant, setParticipant]=useState(undefined);
    const [manParticipant,setManParticipant]=useState(undefined);
    const [showManual,setShowManual]=useState(false);
    const [resBlocks, setResBlocks]=useState([]);
    const [manEntry, setManEntry]=useState("");
    const [manConfirm,setManConfirm]=useState(false);
    //hardcoded for testing  remove the fixed date for production
    
    const currTime =new Date().getHours();

    const getTomorrow=()=>{
        let tmrow = new Date();
        let offset = Number(area.LotteryAdvance);
        tmrow.setDate(tmrow.getDate() + offset);
        console.log(tmrow);
        if (test){
            const day1 = new Date("07/23/2026");
            if (tmrow< day1){
                tmrow = (new Date(day1));
            }
        }
        setTomorrow(tmrow);
    }

    const openManual=()=>{
        console.log("Open Manual");
        clearParticipant();
        setShowManual(true);
    }

    const closeManual=()=>{
        setShowManual(false);
    }

    const openScanner=()=>{

        setScanValue("");
    }
    const hideScanner=()=>{

        setShowScanner(false);
    }


    const checkEligible = async ()=>{
        console.log(scanValue);
        console.log(area.AreaID);
        let today = new Date();
        //const day1 = new Date("07/23/2026");

        //if (today< day1){
        // today = (new Date(day1));
        //}
        const ckToday = today.toISOString().split('T')[0];
        const params=new URLSearchParams({id:scanValue, area:area.AreaID});
        const url= "api/index.php/program/getRes?" + params;
        fetch (url,{
            method:"GET"
        }).then(response=>response.json()).then(async data=> {
            console.log(data);
            let count=0;
            if (data.length>0){
                data.forEach(row=>{
                    if (row.Complete>=1){
                        count++;
                    }
                    // if (row.Complete===0 && row.Date===ckToday){
                    //     count++;
                    // }
                })
                if (count>= area.LimitDays){
                    setMaxRides(true);
                }else{
                    makeReservatiion();
                }            
            }else{
                setMaxRides(false);
                makeReservatiion();
            }
        })
    }

    const getParticipant = async ()=>{
        const params=new URLSearchParams({id:scanValue, name:""});
        const url= "api/index.php/program/getParticipant?" + params;
        fetch (url,{
            method:"GET"
        }).then(response=>response.json()).then(async data=> {
            console.log(data);
            setParticipant(data);
        })
    }

    const makeReservatiion=()=>{
        const tmdt = tomorrow.toISOString().split('T')[0];
        console.log("Make Reservation: " + area.AreaID + " " + tmdt);
        const postData = new FormData();
        const url= "api/index.php/program/insertReservation";
        postData.append("id",scanValue);
        postData.append("areaId",area.AreaID);
        postData.append("date",tmdt);
        fetch (url,{
            method:"POST",
            body:postData
        }).then(response=>response.json()).then(async data=> {
            console.log(data);
            if (data==0){
                setResExists(true);
            }
        })
    }

    const getPAFromKey = async ()=>{
        //const domain = window.location.host;
        const url= "api/index.php/auth/getPaFromKey?key="+key;
        fetch (url,{
            method:"GET"
        }).then(response=>response.json()).then(async data=> {
            console.log(data);
            if (data.length>0){
                console.log(data[0]);
                setArea(data[0]);
            }else{
                setArea({
                AreaID: "NONE",
                AreaName: "",
                Status: "",
                ContactName: "",
                ContactPhone: "",
                CheckIn: 0,
                AgeCheck: 0,
                ResCheck: 0,
                });
            }
        })
    }

    const checkBlocks = async ()=>{
        const year = ''+tomorrow.getFullYear();
        let month = ''+(tomorrow.getMonth()+1);
        let day = ''+tomorrow.getDate();
        if (month.length<2){
            month = "0" +month;
        }
        if (day.length<2){
            day = "0"+day;
        }
        const dtParam = [year,month,day].join("-");
        //const tmdt='2026-07-23';
        const params=new URLSearchParams({area:area.AreaID, date:dtParam});

        const url = "api/index.php/program/getAvailableBlocks?"+params;
        fetch (url,{
            method:"GET"
        }).then(response=>response.json()).then(async data=> {
            if (data.length>0){
                console.log(data);
                console.log("Has open blocks");
                setHasBlocks(true);
            }else{
                console.log("No open blocks");
                setHasBlocks(false);
            }
        })
    }
    const clearParticipant=()=>{
        setManParticipant(undefined);
    }

    const ManualEntry=()=>{
        const manualIDChange=(event)=>{
            console.log(event.value);
            setManEntry(event.value);
        }
        const checkManParticipant = async ()=>{
            if (manEntry!=""){
                const params=new URLSearchParams({id:manEntry, name:""});
                const url= "api/index.php/program/getParticipant?" + params;
                fetch (url,{
                    method:"GET"
                }).then(response=>response.json()).then(async data=> {
                    console.log(data);
                    setManParticipant(data);
                })
            }
        }
        
        const saveManual=()=>{
            setScanValue(manParticipant[0].MemberId)
            closeManual();
            hideScanner();
            setManEntry("");
        }

        return(
            <Dialog className='atol-dlg-error' title={"Enter manual ID"} onClose={closeManual}>
                <p>Enter the ID number found on your Jamboree ID</p>
                <Input onChange={manualIDChange} value={manEntry}></Input>
                {manParticipant?    
                <>
                <p>Are you {manParticipant[0].NameFirst} {manParticipant[0].NameLast}?</p>
                <Button onClick={saveManual}>Yes</Button>
                <Button onClick={clearParticipant}>No</Button>    
                </>
                :null}
                <DialogActionsBar>
                    {manConfirm?
                        <Button>Save</Button>                
                    :
                        <Button onClick={checkManParticipant}>Check ID</Button>
                    }

                </DialogActionsBar>
            </Dialog>
        )
    }

   const onScan=(err,result)=>{
        if (result){
            console.log(result);
            setScanValue(result.text);
            hideScanner();
        }
    }

    useEffect(()=>{
        if (showScanner){
            setIsYouth(false);
            setResExists(false);
        }
    },[showScanner])

    useEffect(()=>{
        if (isYouth){
            checkEligible();
        }
    },[isYouth])

    useEffect(()=>{
        if (participant!=undefined){
            const age = participant[0].EventAge;
            const variant =participant[0].Variant;
            let youth = false;
            if (age==="Under 14"||age==="14-17"){
                //if age is under 18
                if (!variant.includes("Staff")){
                    //exclude youth staff
                    youth = true;
                }
            }else{
                //age is over 18
                if (age==="18-26"){
                    if (variant==="Scouts BSA - Male Youth"||variant==="Venturing - Youth (All Genders)"||variant==="Sea Scouts - Youth (All Genders)" || variant==="Scouts BSA - Combined Youth"|| variant==="Scouts BSA - Female Youth"){
                        //youth program participants
                        youth=true;
                    }
                }
            }
            setIsYouth(youth);
        }
    },[participant])

    useEffect(()=>{
        console.log(scanValue);
        if (scanValue===""){
            setShowScanner(true);
        }else{
            //checkEligible()
            getParticipant();
        }
    },[scanValue])

    useEffect(()=>{
        //check available reservation blocks for tomorrow
        console.log(area);
        if (area!=undefined){
            if (area.AreaID!==""){
                if (test){
                    setResOpen(true);
                    getTomorrow();
                }else{
                    //if (area.Status!="CLOSED"){
                        console.log("Area is not closed");
                        if (test){
                            setResOpen(true);
                        }else{
                            if (currTime>7 && currTime<17){
                            setResOpen(true);
                            }
                        }
                        getTomorrow();
                    //}else{
                    //    console.log("Area is closed");
                    //}
                }

            }
        }
    },[area])

    useEffect(()=>{
        console.log("Res Open");
        console.log(resOpen);
    },[resOpen])

    useEffect(()=>{
        console.log(tomorrow);
        if (tomorrow!=undefined&&tomorrow!="Invalid Date"){
            checkBlocks();
        }
    },[tomorrow])

    useEffect(()=>{
        console.log("Reservation Form")
        if (key && key!==""){
            getPAFromKey();
        }   
    },[])

    return(
        area!=undefined?
            <div className="App">
            <AreaTitle area={area.AreaName}></AreaTitle>
            {resOpen?
                //Reservations are open and slots are availabe.
                <>
                {hasBlocks?
                    <>
                    {showScanner?
                        <>
                        {showManual?
                            <ManualEntry></ManualEntry>
                        :null}
                        <div style={{fontSize:"xxx-Large", textAlign:"center"}}><FontAwesomeIcon icon={faCamera} /></div>
                        <h3>Request a reservation</h3>
                        {area.AreaID==="NJ26-LHSS"?
                        <p>This lottery is for on-stage seating reservations for the keynote speaker. All Jamboree participants, staff, and visitors are welcome and encouraged to attend the keynote speaker session in the general admission seating area in front of the stage.</p>
                        :null}
                        <p>Scan the barcode on your Jamboree ID<br/>to request a reservation for:</p>
                        <h4>{area.AreaName}</h4>
                        <p>on</p>
                        <h4>{tomorrow.toDateString()}</h4>
                        <Button onClick={openManual}>Having trouble reading the barcode?</Button>
                        <BarcodeScanner onUpdate={onScan}></BarcodeScanner>
                        </>
                    :
                        //display scan results
                        <>
                        {isYouth===false?
                            //No adults allowed
                            <div className={"scanResult stop"}>
                                <div style={{fontSize:"xxx-Large"}}><FontAwesomeIcon icon={faFaceFrown} /></div>
                                <h1>Youth Only</h1>
                                <p>Sorry. Reservations are reserverved for youth participants only.</p>
                                <p>{scanValue}</p>
                                <Button size='large' fillMode='outline' style={{color:"white", width:"95%"}} onClick={openScanner}>Scan Another ID</Button>
                            </div>                        
                        :
                        maxRides?
                            <>
                                <div className={"scanResult stop"}>
                                    <div style={{fontSize:"xxx-Large"}}><FontAwesomeIcon icon={faFaceFrown} /></div>
                                    <h1>Maximum Fun Exceeded</h1>
                                    <p>Sorry. You have reached the maximum number of turns for this activity, or you have an active, unused reservation for today.<br/>Be sure to get out and visit all of the other exciting Jamboree activity areas.</p>
                                    <p>{scanValue}</p>
                                    <Button size='large' fillMode='outline' style={{color:"white", width:"95%"}} onClick={openScanner}>Scan Another ID</Button>
                                </div>
                            </>
                        :
                            resExists?
                                //reservation already exists
                                <>
                                    <div className={"scanResult go"}>
                                        <div style={{fontSize:"xxx-Large"}}><FontAwesomeIcon icon={faFaceSmile} /></div>
                                        <h1>Existing Request</h1>
                                        <h3>A reservation request has<br/>already been submitted for:</h3>
                                        <p>{scanValue}</p>
                                        <p>{tomorrow.toDateString()}</p>
                                        <p>Scan your id barcode again after 6:00 PM to see if your request has been selected and to verify your designated check-in time and location.</p>
                                        <Button size='large' fillMode='outline' style={{color:"white", width:"95%"}} onClick={openScanner}>Scan Another ID</Button>
                                    </div>
                                </>
                            :
                                    <div className={"scanResult go"}>
                                        <div style={{fontSize:"xxx-Large"}}><FontAwesomeIcon icon={faFaceSmile} /></div>
                                        <h1>Reservation<br/>request saved for:</h1>
                                        <p>{scanValue}</p>
                                        <p>{tomorrow.toDateString()}</p>
                                        <p>Scan your id barcode again after 6:00 PM to to see if your request has been selected and to verify your designated check-in time and location.</p>
                                        <Button size='large' fillMode='outline' style={{color:"white", width:"95%"}} onClick={openScanner}>Scan Again</Button>
                                    </div> 
                        }                 
                        </>
                    }
                    </>
                :
                //No reservations slots configured for the selected date
                    <div className={"scanResult stop"}>
                        <div style={{fontSize:"xxx-Large"}}><FontAwesomeIcon icon={faFaceFrown} /></div>
                        <h1>No Spaces Available</h1>
                        <p>for</p>
                        <p>{tomorrow.toDateString()}</p>
                        <p>This area does not have any spaces available for reservations for the specified date.<br/>Reservation requests for the following day are accepted between 8 a.m. and 5 p.m. daily beginning on July 22, 2026</p>
                    </div>  
                }
                </>
            :
                // Reservations closed. Outside the resevervation window of 8 AM - 5 PM                
                <div className={"scanResult stop"}>
                    <div style={{fontSize:"xxx-Large"}}><FontAwesomeIcon icon={faFaceFrown} /></div>
                    <h1>Reservations Closed</h1>
                    <p>for</p>
                    <p>{tomorrow!=undefined?tomorrow.toDateString():area.AreaName}</p>
                    <p>Reservation requests for the following day are accepted between 8 a.m. and 5 p.m. daily beginning on July 22, 2026</p>
                </div>
            }
            </div>
        :
            //Inavid program areas.
            <div className={"scanResult stop"}>
                <div style={{fontSize:"xxx-Large"}}><FontAwesomeIcon icon={faFaceFrown} /></div>
                <h1>Invalid Program Area</h1>
                <p>The specified program area was not found.</p>
            </div>  
    )
}